import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class CategoryIndex extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: number): CategoryIndex {
    if (value < 1) {
      throw new Error('1以上である必要があります');
    }
    return new CategoryIndex(value);
  }

  /**
   * キー
   */
  static get key(): string {
    return 'noticeIndex';
  }

  /**
   * タイプ
   */
  static get type(): string {
    return 'number';
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '掲示順';
  }

  /**
   * PlaceHolder
   */
  static get placeholder(): number {
    return 1;
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value.toString();
  }
}
